/*
  Copy-link button inside snippets/share-links.liquid. The other targets in the
  list are plain links and need no JavaScript.
*/
if (!customElements.get('share-links')) {
  class ShareLinks extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    disconnectedCallback() {
      clearTimeout(this.resetTimer);
    }

    handleClick(event) {
      const button = event.target.closest('[data-share-copy]');

      if (!button) return;

      event.preventDefault();
      this.copy(button);
    }

    copy(button) {
      // Falls back to the page's own URL so the button still works if the
      // markup was rendered without one.
      const url = button.dataset.shareUrl || window.location.href;

      if (!navigator.clipboard) return;

      // Denied clipboard permission and insecure contexts both reject here.
      navigator.clipboard.writeText(url).then(this.announce.bind(this), () => {});
    }

    announce() {
      const status = this.querySelector('[data-share-status]');

      this.classList.add('share-links--copied');

      if (status) status.textContent = this.dataset.copiedLabel || '';

      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.classList.remove('share-links--copied');
        if (status) status.textContent = '';
      }, 3000);
    }
  }

  customElements.define('share-links', ShareLinks);
}
